import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../app/Hooks';

type Props = {
  children: React.ReactElement;
};

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { token } = useAppSelector(state => state.login);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
